"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.renderPreferences = exports.preferences = void 0;
var Alerts_1 = require("./Alerts");
//Preferences toggle functionality
var preferences = function () {
    var selectAll = undefined;
    var saveButton = document.querySelector('#save');
    var selectAllButton = document.querySelector('#select');
    var deselectAllButton = document.querySelector('#deselect');
    var topicInputs = Array.from(document.querySelectorAll('.topic'));
    var permissionsAcceptButton = document.querySelector('#grant-permissions');
    var dropdownButtons = Array.from(document.querySelectorAll('.dropdown button'));
    var preferencesInputs = Array.from(document.querySelectorAll('.preferences-list input'));
    //Toogles all preferences based on parameter
    var toggleAllPreferences = function (boolean) {
        preferencesInputs.map(function (input) {
            input.checked = boolean;
            input.classList.remove('intermediate');
        });
        updateConsentAllNone(boolean);
    };
    //update consent, all or none buttons, and selectall variable on select all or none
    var updateConsentAllNone = function (value) {
        permissionsAcceptButton.checked = value;
        selectAllButton.closest('div').setAttribute('data-all', String(value));
        selectAll = value;
    };
    // Logic to brands and topic inputs for toggle
    var togglePreferenceLogic = function (input, init) {
        var topicsChecked = 0;
        var topicsIntermediate = 0;
        var topic = input.getAttribute('data-topic');
        var topicId = input.getAttribute('data-topic-id');
        var relatedTopicInputs = Array.from(document.querySelectorAll("[data-topic-id=".concat(topicId, "]")));
        if (!init) {
            checkForDuplicateBrands(input);
            input.classList.remove('intermediate');
        }
        if (input == relatedTopicInputs[0] && !init) {
            relatedTopicInputs.map(function (topicInput, index) {
                if (index != 0) {
                    topicInput.checked = input.checked;
                    checkForDuplicateBrands(topicInput);
                    topicInput.classList.remove('intermediate');
                }
                if (!permissionsAcceptButton.checked)
                    permissionsAcceptButton.checked = true;
            });
            if (!input.checked)
                Alerts_1["default"].createNewAlert(topicId, topic);
            relatedTopicInputs[0].classList.remove('intermediate');
        }
        else {
            relatedTopicInputs.map(function (topicInput, index) {
                if (index != 0) {
                    if (topicInput.checked)
                        topicsChecked++;
                    if (topicInput.classList.contains('intermediate'))
                        topicsIntermediate++;
                    if (!permissionsAcceptButton.checked)
                        permissionsAcceptButton.checked = true;
                }
            });
            setTopicLevelStatus(topicsChecked, topicsIntermediate, relatedTopicInputs);
        }
        checkIfAllOrNoPreferencesAreChecked();
    };
    //Set Topic check status checked, unchecked, or intermediate
    var setTopicLevelStatus = function (checked, intermediate, inputs) {
        if (checked == 0 && intermediate == 0) {
            inputs[0].checked = false;
            inputs[0].classList.remove('intermediate');
        }
        else if (checked == inputs.length - 1) {
            inputs[0].checked = true;
            inputs[0].classList.remove('intermediate');
        }
        else {
            inputs[0].checked = false;
            inputs[0].classList.add('intermediate');
        }
    };
    //Checks manually inputs for all selection, none, or inbetween
    var checkIfAllOrNoPreferencesAreChecked = function () {
        var anyIntermediate = document.querySelector('[data-brand].intermediate') ? true : false;
        var anyUnchecked = document.querySelector('.preferences-list input:not(:checked)') ? true : false;
        var anyChecked = document.querySelector('.preferences-list input:checked') || anyIntermediate ? true : false;
        if (anyChecked && anyUnchecked) {
            selectAllButton.closest('div').setAttribute('data-all', '');
            selectAll = undefined;
        }
        else if (!anyChecked && anyUnchecked) {
            updateConsentAllNone(false);
        }
        else {
            updateConsentAllNone(true);
        }
    };
    //Set checked status of topic input (checked or intermediate)
    var initSetTopicStatus = function () {
        topicInputs.map(function (item) {
            togglePreferenceLogic(item, true);
        });
    };
    //Toggles dropdown
    var handleDropdown = function (element) {
        var parent = element.parentElement.parentElement;
        parent.classList.toggle('active');
    };
    /*Check for duplicate brands when selecting a brand a select that brand if exists under different topic */
    var checkForDuplicateBrands = function (element) {
        var brand = element.getAttribute('data-brand-id');
        var duplicateBrands = brand ? Array.from(document.querySelectorAll("[data-brand-id=".concat(brand, "]"))) : [];
        duplicateBrands.map(function (input) {
            if (input != element && input.checked != element.checked)
                input.click();
        });
    };
    //Takes DOM inputs and creates data object for post
    var createPostDataObject = function () {
        var data;
        var updatedInputs = Array.from(document.querySelectorAll('[data-brand-id]'));
        if (selectAll == true || selectAll == false) {
            data = {
                omniId: omni,
                emailAddress: email,
                response: [{ Brand: 'All Company', Topic: 'N/A', Status: selectAll ? 'true' : 'false', Consent: '' }]
            };
        }
        else {
            data = updatedInputs.reduce(function (acc, curr) {
                if (!acc['response'])
                    acc['response'] = [];
                var status = curr.getAttribute('data-status');
                var determineStatus = (curr.checked && status == '2') || (!curr.checked && status == '0') || curr.classList.contains('intermediate')
                    ? 'unchanged'
                    : String(curr.checked);
                acc['response'].push({
                    Status: determineStatus,
                    Brand: curr.getAttribute('data-brand'),
                    Topic: curr.getAttribute('data-topic'),
                    Consent: curr.getAttribute('data-consent')
                });
                return acc;
            }, { omniId: omni, emailAddress: email });
        }
        return data;
    };
    //Handles data construction and ajax call
    var saveDataChanges = function () {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                Alerts_1["default"].createNewAlert();
            }
        };
        xhttp.open("POST", window.location.origin + '/', true);
        xhttp.setRequestHeader("Content-Type", "application/json");
        xhttp.send(JSON.stringify(createPostDataObject()));
    };
    //Handle adding event listeners
    var handleEvents = function () {
        preferencesInputs.map(function (input) {
            input.addEventListener('change', function () {
                togglePreferenceLogic(input, false);
            });
        });
        dropdownButtons.map(function (button) {
            button.addEventListener('click', function () {
                handleDropdown(button);
            });
        });
        saveButton.addEventListener('click', function () { saveDataChanges(); });
        selectAllButton.addEventListener('click', function () { toggleAllPreferences(true); });
        deselectAllButton.addEventListener('click', function () { toggleAllPreferences(false); });
        permissionsAcceptButton.addEventListener('click', function () { toggleAllPreferences(permissionsAcceptButton.checked); });
    };
    //Functions to run when parent is called
    var init = function () {
        initSetTopicStatus();
        handleEvents();
    };
    init();
};
exports.preferences = preferences;
//Preferences render on load
var renderPreferences = function () {
    var numberOfTopicColumns = 2;
    var preferencesWrapper = document.querySelector('.preferences-list');
    /*Dynamically create and load Topics and Brands list items to make*/
    var initRenderToPage = function () {
        var newTopicsArray = topics.reduce(function (acc, curr) {
            var topic = curr.Topic;
            var category = curr.Category;
            if (topic == 'N/A')
                return acc;
            if (!acc[topic])
                acc[topic] = { noCategory: [] };
            if (acc[topic] && !acc[topic][category] && category != null)
                acc[topic][category] = [];
            category != null ?
                acc[topic][category].push(curr) :
                acc[topic].noCategory = __spreadArray(__spreadArray([], acc[topic].noCategory, true), [curr], false);
            return acc;
        }, {});
        var sliceIntoColumns = function (array) {
            var columns = [];
            var numberOfColumns = Math.round(array.length / numberOfTopicColumns);
            for (var i = 0; i < array.length; i += numberOfColumns) {
                var column = array.slice(i, i + numberOfColumns);
                columns.push(column);
            }
            return columns;
        };
        var slicing = 1;
        var Category = Object.keys(newTopicsArray[Object.keys(newTopicsArray)[slicing]]);
        var CategoryTitle = Category.slice(slicing, slicing + 1)[0] != 'noCategory' ? "<span class=\"sub-topic\">".concat(Category.slice(slicing, slicing + 1), "</span>") : '';
        var columns = sliceIntoColumns(Object.keys(newTopicsArray));
        var datas = createColumnTopicsContent(newTopicsArray, columns, slicing);
        preferencesWrapper.innerHTML = '<div class="category">' + CategoryTitle + datas + '</div>';
        slicing = slicing + 1;
        var Categories = Object.keys(newTopicsArray[Object.keys(newTopicsArray)[slicing]]);
        var CategoriesTitle = Categories.slice(slicing, slicing + 1)[0] != 'noCategory' ? "<span class=\"sub-topic\">".concat(Categories.slice(slicing, slicing + 1), "</span>") : '';
        datas = createColumnTopicsContent(newTopicsArray, columns, slicing);
        preferencesWrapper.innerHTML = preferencesWrapper.innerHTML + '<div>' + CategoriesTitle + datas + '</div>';
    };
    /* Create topic lists and columns */
    var createColumnTopicsContent = function (array, keys, slicing) {
        var createTopicContent = keys.reduce(function (acc, item) {
            return acc + "\n        ".concat((function () {
                return item.reduce(function (accTopics, topic) {
                    var Categories = Object.keys(array[topic]);
                    var topicId = topic.replace(/[^A-Z0-9]+/ig, '');
                    var data_topicid = topicId + "_" + slicing;
                    return accTopics + "<ul class=\"list\">\n              <li>\n                <div class=\"dropdown\">\n                    <label class=\"custom-checkbox\">\n                        ".concat(topic, "\n                        <input \n                          class=\"topic\" \n                          type=\"checkbox\"\n                          data-topic=\"").concat(topic, "\"\n                          data-topic-id=").concat(data_topicid, ">\n                        <span class=\"checkmark\"></span>\n                    </label>\n                    <button></button>\n                </div>\n\n                  ").concat((function () {
                        return Categories.slice(slicing, slicing + 1).sort().reduce(function (accTopicSection, subTopic) {
                            var CategoriesArray = array[topic][subTopic];
                            return accTopicSection + "<ul>\n                        ".concat((function () {
                                return CategoriesArray.reduce(function (accCategories, brand) {
                                    var status = brand.Status == 2 ? 'checked' : '';
                                    var brandId = (brand.Brand).replace(/[^A-Z0-9]+/ig, '');
                                    var intermediate = brand.Status == 1 ? 'intermediate' : '';
                                    return accCategories + "<li>\n                                <label class=\"custom-checkbox\">\n                                    ".concat(brand.Brand, "\n                                    <input              \n                                      ").concat(status, "\n                                      type=\"checkbox\"\n                                      data-topic=\"").concat(topic, "\"\n                                      class=\"").concat(intermediate, "\"\n                                      data-brand-id=\"").concat(brandId, "\"\n                                      data-topic-id=\"").concat(data_topicid, "\"\n                                      data-brand=\"").concat(brand.Brand, "\"\n                                      data-status=\"").concat(brand.Status, "\"\n                                      data-consent=\"").concat(brand.Consent, "\">\n                                    <span class=\"checkmark\"></span>\n                                </label>\n                            </li>");
                                }, '');
                            })(), "\n                      </ul>");
                        }, '');
                    })(), "\n              </li>\n            </ul>");
                }, '');
            })(), "\n     ");
        }, '');
        return createTopicContent;
    };
    //Functions to run when parent is called
    var init = function () {
        initRenderToPage();
    };
    init();
};
exports.renderPreferences = renderPreferences;
